import "@sudo/tokens/tokens.css";
import "@/styles/app.css";

import { createApp } from "vue";
import App from "@/App.vue";
import { router } from "@/router";

createApp(App).use(router).mount("#app");
